export enum ReportCustomizationReducerActions {
  ChangeReportType = "ChangeReportType",
  ChangeMemberships = "ChangeMemberships",

  ChangeTimeslice = "ChangeTimeslice",
  ChangeIsCompareMode = "ChangeIsCompareMode",
  ChangeComparedTimeslice = "ChangeComparedTimeslice",
  ChangeChangedGapsFilter = "ChangeChangedGapsFilter",

  ChangeFilename = "ChangeFilename",
  ChangeFileFormat = "ChangeFileFormat",
  ChangeReportFormat = "ChangeReportFormat",

  ChangeSharedUsers = "ChangeSharedUsers",
  ChangeShouldEmailLink = "ChangeShouldEmailLink",

  ChangeSelectedCounties = "ChangeSelectedCounties",
  ChangeSelectedStates = "ChangeSelectedStates",
  ChangeServiceAreaGapsType = "ChangeServiceAreaGapsType",
  ChangeIncludeActive = "ChangeIncludeActive",
  ChangeIncludePending = "ChangeIncludePending",
  ChangeIncludeApproved = "ChangeIncludeApproved",
  ChangeIncludeOpportunity = "ChangeIncludeOpportunity",

  ChangeSelectedSpecialtes = "ChangeSelectedSpecialtes",
  ChangeSpecialtyGapsType = "ChangeSpecialtyGapsType",
  ChangeIncludePhysicianSpecialties = "ChangeIncludePhysicianSpecialties",
  ChangeIncludeFacilitySpecialties = "ChangeIncludeFacilitySpecialties",
  ChangeIncludeExpandableSpecialties = "ChangeIncludeExpandableSpecialties",

  ChangeProviderSource = "ChangeProviderSource",
  ChangeAppendNextClosestProviders = "ChangeAppendNextClosestProviders",
  ChangeAppendPatternOfCare = "ChangeAppendPatternOfCare",
  ChangeProviderFilter = "ChangeProviderFilter",
  ChangeShowAddedProviders = "ChangeShowAddedProviders",
  ChangeShowMatchedProviders = "ChangeShowMatchedProviders",
  ChangeShowRemovedProviders = "ChangeShowRemovedProviders",

  ChangeIncludeCargo = "ChangeIncludeCargo",

  ChangeLoadedPresets = "ChangeLoadedPresets",
  ChangeSelectedPreset = "ChangeSelectedPreset",

  LoadPage = "LoadPage",
  ChangeIsGenerating = "ChangeIsGenerating",
}